var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "umapContainer",
      staticClass: "umap-container",
      staticStyle: {
        width: "100%",
        position: "relative",
        "overflow-x": "hidden",
      },
      on: {
        mousedown: _vm.onMouseDown,
        mousemove: _vm.onMouseMove,
        mouseup: _vm.onMouseUp,
        mouseleave: _vm.onMouseLeave,
        mouseover: _vm.onMouseOver,
        mouseout: _vm.onMouseOut,
        wheel: function ($event) {
          $event.preventDefault()
          return _vm.onWheel.apply(null, arguments)
        },
        contextmenu: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.expression
        ? _c(
            "div",
            {
              staticClass: "legend",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                position: "absolute",
                top: "4px",
                left: "5px",
              },
            },
            [
              _c("div", { staticClass: "label" }, [_vm._v("Expression")]),
              _c("div", {
                staticClass: "gradient",
                style: `background: linear-gradient(to right, ${_vm.colorScaleArray()}); height:5px;`,
              }),
              _c(
                "div",
                { staticClass: "marks", staticStyle: { display: "flex" } },
                [
                  _c("div", [_vm._v(_vm._s(_vm.minExpressionValue()))]),
                  _c("div", [_vm._v(_vm._s(_vm.maxExpressionValue()))]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.points
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "flex-end",
                gap: "5px",
                position: "absolute",
                right: "5px",
                top: "5px",
                "z-index": "1",
              },
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      modifiers: { hover: true, bottom: true },
                    },
                  ],
                  style: !_vm.showTooltips
                    ? "background:#ddd"
                    : "background:white",
                  attrs: { title: "toggle cell info" },
                  on: {
                    click: function ($event) {
                      _vm.showTooltips = !_vm.showTooltips
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "12px", margin: "0 4px" },
                      attrs: {
                        viewBox: "0 0 15.098 18.794",
                        "xml:space": "preserve",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { transform: "translate(-.27 -.301)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M.77 14.361V.801h14.098v13.56H10.51l-2.853 4.234-2.605-4.234z",
                              fill: "none",
                              stroke: "#000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _c("circle", {
                            attrs: { cx: "7.845", cy: "4.296", r: ".979" },
                          }),
                          _c("path", {
                            attrs: { d: "M7.094 5.928h1.501v5.876H7.094z" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      modifiers: { hover: true, bottom: true },
                    },
                  ],
                  style: !_vm.showLabels
                    ? "background:#ddd"
                    : "background:white",
                  attrs: { title: "toggle labels" },
                  on: { click: _vm.toggleLabels },
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "20px" },
                      attrs: {
                        viewBox: "0 0 50 50",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xml:space": "preserve",
                        transform: "rotate(270)",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M24.896 9.463a.997.997 0 0 0-.707-.293l-12.957-.001a1 1 0 0 0-1 .996l-.046 13.005a.998.998 0 0 0 .293.711l16.995 16.995a.997.997 0 0 0 1.414 0l13.004-13.004a.999.999 0 0 0 0-1.414L24.896 9.463zm3.285 29.292L12.188 22.761l.041-11.592 11.547.001 15.995 15.995-11.59 11.59z",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "20.362", cy: "19.346", r: "2.61" },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      modifiers: { hover: true, bottom: true },
                    },
                  ],
                  attrs: { title: "recenter" },
                  on: { click: _vm.resetPanZoom },
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "18px" },
                      attrs: {
                        viewBox: "0 0 32 32",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M6 12H4V4h8v2H6v6zM28 12h-2V6h-6V4h8v8zM12 28H4v-8h2v6h6v2zM28 28h-8v-2h6v-6h2v8zM15 10h2v4h-2zM10 15h4v2h-4zM18 15h4v2h-4zM15 18h2v4h-2z",
                        },
                      }),
                      _c("path", {
                        attrs: { fill: "none", d: "M0 0h32v32H0z" },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom.html",
                      modifiers: { hover: true, bottom: true, html: true },
                    },
                  ],
                  attrs: {
                    title: _vm.is3dMode
                      ? "zoom: mouse wheel<br>rotate: click + drag<br>pan: shift + drag or right drag"
                      : "zoom: mouse wheel<br>pan: click + drag",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "18px" },
                      attrs: {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M12 19.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0 1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm.75-6v1.5h-1.5V15h1.5Zm-2.25-4.568C10.5 9.662 11.15 9 12 9s1.5.663 1.5 1.432c0 .307-.185.671-.592 1.084-.395.4-.898.743-1.315 1.013l-.343.222v1.499h1.5v-.688c.381-.259.833-.595 1.225-.992.507-.514 1.025-1.24 1.025-2.138C15 8.79 13.635 7.5 12 7.5s-3 1.291-3 2.932h1.5Z",
                          fill: "#000",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      modifiers: { hover: true, bottom: true },
                    },
                  ],
                  attrs: { title: "Download" },
                  on: { click: _vm.download },
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "24px" },
                      attrs: {
                        fill: "#000000",
                        viewBox: "0 0 1024 1024",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
                        _c("path", {
                          attrs: {
                            d: "M512 666.5L367.2 521.7l36.2-36.2 83 83V256h51.2v312.5l83-83 36.2 36.2L512 666.5zm-204.8 50.3V768h409.6v-51.2H307.2z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("canvas", {
        ref: "umapCanvas",
        staticClass: "umap-canvas",
        on: { click: _vm.onClick },
      }),
      _c("canvas", {
        ref: "umapLabelCanvas",
        staticClass: "umap-label-canvas",
        style: `display:${_vm.showLabels ? "block" : "none"}`,
      }),
      _vm.is3dMode
        ? _c("canvas", {
            ref: "axisIndicatorCanvas",
            staticClass: "umap-axis-indicator",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }